import * as React from 'react';
import { IHeiProductPromotionsViewProps } from './hei-product-promotions';
import { IGetProductPromotionResponse } from '../../actions/DataServiceEntities.g';

export default (props: IHeiProductPromotionsViewProps) => {
    const {
        data: { productPromotions, productInfo },
        context: {
            request: { sitePath }
        }
    } = props;

    const [promotions, setPromotions] = React.useState(productPromotions.result?.Promotions ?? []);

    React.useEffect(() => {
        const listener = (evt: Event) => {
            const customEvt = evt as CustomEvent<IGetProductPromotionResponse>;
            process.env.NODE_ENV === 'development' && console.log('hei-product-promotions', customEvt.detail);

            if (customEvt.detail) {
                setPromotions(customEvt.detail.Promotions ?? []);
            }
        };

        window.addEventListener('onProductPromotionsChange', listener);

        return () => {
            window.removeEventListener('onProductPromotionsChange', listener);
        };
    }, []);

    const offers = promotions.filter(o => o.OfferId);
    const productRebate = productInfo.result?.RebateHtml;
    const hasContent = (offers && offers.length > 0) || !!productRebate;

    if (hasContent) {
        return (
            <div className='hei-product-promotions'>
                {!!productRebate && <div className='hei-product-rebate' dangerouslySetInnerHTML={{ __html: productRebate }} />}
                {offers && offers.length > 0 && (
                    <ul className='hei-buybox-promotion-list'>
                        {offers.map(o => {
                            return (
                                <li key={o.OfferId} className='hei-buybox-promotion-item' data-offer={o.OfferId}>
                                    <a href={`${sitePath ?? ''}/promotion/${o.OfferId?.toLowerCase()}`}>{o.Name}</a>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        );
    }

    return (
        <div className='hei-product-promotions'>
            <span>There&apos;s no offer available at this time.</span>
        </div>
    );
};
